// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RDtwg","row":"styles_row__O1zEv","productsList":"styles_productsList__qPN7-","item":"styles_item__30yE2","buttonCell":"styles_buttonCell__GCoXW"};